import Image from '@repo/ui/src/components/Image';

interface Props {
  flag: string;
  name: string;
  current?: string;
}
export const CountryDetails = ({ flag, name }: Props) => (
  <>
    <div className="tw-relative tw-w-8/12 tw-aspect-video tw-mx-auto md:tw-w-full">
      <Image src={flag} alt={`${name} flag`} layout="fill" />
    </div>
    <h5 className="tw-text-white tra-text-web-heading-5 tw-mt-3 tw-text-center">{name}</h5>
  </>
);
